import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

export default function LogoutTestPage() {
    const { user, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [status, setStatus] = useState('');

    const handleTest = async () => {
        try {
            setStatus('Tentative de déconnexion...');
            console.log('Utilisateur avant:', user?.email);

            await logout();

            setStatus('Déconnexion réussie!');
            console.log('Utilisateur après:', user?.email);

            setTimeout(() => {
                navigate('/');
            }, 1500);
        } catch (error) {
            setStatus(`Erreur: ${error.message}`);
            console.error('Erreur:', error);
        }
    };

    return (
        <div style={{ padding: '40px', color: '#d4af37', background: '#0a0a0a', minHeight: '100vh' }}>
            <h1>Test Déconnexion</h1>

            <div style={{ marginBottom: '20px' }}>
                <p><strong>Utilisateur:</strong> {user?.email || 'Aucun'}</p>
                <p><strong>Status:</strong> {status}</p>
            </div>

            <button
                onClick={handleTest}
                style={{
                    padding: '10px 20px',
                    background: '#d4af37',
                    color: '#0a0a0a',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                }}
            >
                Tester la déconnexion
            </button>
        </div>
    );
}
